import { IconX } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Drawer } from '@zorro/design-system/v2/Drawer';
import { parseDateISO } from '@zorro/shared/formatters';
import { Badge, Group, Text, brand } from '@zorro/web/design-system';

import { Comments } from './Comments';

type Props = {
  shouldShowComments: boolean;
  onboardingPeriodId: string;
  isSpecialEnrollment: boolean;
  enrollmentStartDate: string | null;
  employeeId: string;
  fullName: string;
  employerId: string;
  commentsCount: number;
  selectedCommentId: string | null;
  setShowComments: (show: boolean) => void;
};

export const CommentsDrawer = ({
  shouldShowComments,
  onboardingPeriodId,
  isSpecialEnrollment,
  enrollmentStartDate,
  employeeId,
  fullName,
  employerId,
  commentsCount,
  selectedCommentId,
  setShowComments,
}: Props) => {
  const enrollmentType = isSpecialEnrollment
    ? 'special enrollment'
    : 'open enrollment';

  return (
    <Drawer
      opened={shouldShowComments}
      title={
        <Group align="center" pos="relative" w="100%" gap="xs">
          <Text size="lg" fw={600}>
            {fullName} {enrollmentType}{' '}
            {enrollmentStartDate
              ? parseDateISO(enrollmentStartDate).year()
              : ''}{' '}
            - Comments
          </Text>

          <Badge
            c="zorroCoal.0"
            p="5px 5px"
            w={22}
            h={22}
            fz={11}
            variant="light"
            bg={brand.zorroGray700}
          >
            {commentsCount}
          </Badge>
          <ActionIcon
            size="md"
            onClick={() => setShowComments(false)}
            pos="absolute"
            right="-25px"
            top="-10px"
          >
            <IconX size={20} color={brand.zorroGray800} />
          </ActionIcon>
        </Group>
      }
      withCloseButton={false}
      onClose={() => setShowComments(false)}
      titleVariant="sticky"
    >
      <Comments
        employerId={employerId}
        employeeId={employeeId}
        onboardingPeriodId={onboardingPeriodId}
        selectedCommentId={selectedCommentId}
      />
    </Drawer>
  );
};
